import React from 'react'
import About from './About'
import Footer from './Footer'
import Map from './Map'
import Projects from './Projects'
import Skills from './Skills'
import Typewriter from './Typewriter'
function Home() {
    return (
        <div className='text-white'>
           <Typewriter/> 
           <About/>
           <Skills/>
           <Projects/>
           <Map/>
           <Footer/>
         </div>
    )
}

export default Home